import React from 'react';

interface LineArrowUpIconProps {
  size?: number;
  color?: string;
}

export const LineArrowUpIcon: React.FC<LineArrowUpIconProps> = ({ size = 24, color = '#686868' }) => {
  return (
    <svg width={size} height={size} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path d="M4 15L12 7L20 15" stroke={color} strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
    </svg>
  );
};
